export default __webpack_public_path__ + "static/media/verified.7ecb90a5.svg";